import GLPostForm from './GLPostForm'
export default GLPostForm
